import { handleInput } from "../../classes/functions";
import "./InputWithLabel.css";

export default function InputWithLabel({ label, name, isRequired, type, state, setState, disabled}){
    return (
        <div className="form__input">
            <label>{label}</label>{isRequired && <>&nbsp;<label className="required">*</label></>}
            <br />
            <input type={type} placeholder={label} name={name} value={state} onChange={(e) => handleInput(setState, e)} disabled={disabled} />
        </div>
    )
}